import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import useTranslations from '../../hooks/useTranslations';
import { pathnameAtom } from '../../atoms/globalAtoms';
import { DICTIONARY } from '../../translations/dictionary';

const TITLE_PREFIX = {
  '/about': 'aboutConfigurator',
  '/instructions': 'instructions',
  '/contact': 'contactUs',
  '/registration': 'registration',
  '/login': 'toLogin',
  '/password': 'forgotPasswordLink',
};

function Head() {
  const { t, lang } = useTranslations();
  const [pathname] = useAtom(pathnameAtom);

  const titlePrefix = useMemo(() => {
    const translationCode = TITLE_PREFIX[pathname];
    if (!translationCode) return '';

    const prefix = t(DICTIONARY[translationCode]);
    if (!prefix) return '';

    return ` - ${prefix}`;
  }, [lang, pathname]);

  return (
    <Helmet>
      <html lang={lang} />
      {lang === 'ru' ? (
        <>
          <title>
            Конфигуратор AIG
            {titlePrefix}
          </title>
          <meta name="description" content="Онлайн-инструмент расчета характеристик стеклоизделий для профессионалов строительной отрасли" />
        </>
      ) : (
        <>
          <title>
            AIG Configurator
            {titlePrefix}
          </title>
          <meta name="description" content="Online tool for calculating glass products characteristics for construction industry professionals" />
        </>
      )}
    </Helmet>
  );
}

export default Head;
